// The 118 elements of the exam's periodic table (long form, 18 groups).
// [number, symbol, ru, kk, en, standard atomic weight ("[n]": mass number of the most stable isotope)]
// Kazakh names follow the school terms (Сутек, Көміртек, Оттек…); the rest match the Russian ones.
const ROWS = [
  [1, "H", "Водород", "Сутек", "Hydrogen", "1.008"],
  [2, "He", "Гелий", "Гелий", "Helium", "4.0026"],
  [3, "Li", "Литий", "Литий", "Lithium", "6.94"],
  [4, "Be", "Бериллий", "Бериллий", "Beryllium", "9.0122"],
  [5, "B", "Бор", "Бор", "Boron", "10.81"],
  [6, "C", "Углерод", "Көміртек", "Carbon", "12.011"],
  [7, "N", "Азот", "Азот", "Nitrogen", "14.007"],
  [8, "O", "Кислород", "Оттек", "Oxygen", "15.999"],
  [9, "F", "Фтор", "Фтор", "Fluorine", "18.998"],
  [10, "Ne", "Неон", "Неон", "Neon", "20.180"],
  [11, "Na", "Натрий", "Натрий", "Sodium", "22.990"],
  [12, "Mg", "Магний", "Магний", "Magnesium", "24.305"],
  [13, "Al", "Алюминий", "Алюминий", "Aluminium", "26.982"],
  [14, "Si", "Кремний", "Кремний", "Silicon", "28.085"],
  [15, "P", "Фосфор", "Фосфор", "Phosphorus", "30.974"],
  [16, "S", "Сера", "Күкірт", "Sulfur", "32.06"],
  [17, "Cl", "Хлор", "Хлор", "Chlorine", "35.45"],
  [18, "Ar", "Аргон", "Аргон", "Argon", "39.948"],
  [19, "K", "Калий", "Калий", "Potassium", "39.098"],
  [20, "Ca", "Кальций", "Кальций", "Calcium", "40.078"],
  [21, "Sc", "Скандий", "Скандий", "Scandium", "44.956"],
  [22, "Ti", "Титан", "Титан", "Titanium", "47.867"],
  [23, "V", "Ванадий", "Ванадий", "Vanadium", "50.942"],
  [24, "Cr", "Хром", "Хром", "Chromium", "51.996"],
  [25, "Mn", "Марганец", "Марганец", "Manganese", "54.938"],
  [26, "Fe", "Железо", "Темір", "Iron", "55.845"],
  [27, "Co", "Кобальт", "Кобальт", "Cobalt", "58.933"],
  [28, "Ni", "Никель", "Никель", "Nickel", "58.693"],
  [29, "Cu", "Медь", "Мыс", "Copper", "63.546"],
  [30, "Zn", "Цинк", "Мырыш", "Zinc", "65.38"],
  [31, "Ga", "Галлий", "Галлий", "Gallium", "69.723"],
  [32, "Ge", "Германий", "Германий", "Germanium", "72.630"],
  [33, "As", "Мышьяк", "Күшән", "Arsenic", "74.922"],
  [34, "Se", "Селен", "Селен", "Selenium", "78.971"],
  [35, "Br", "Бром", "Бром", "Bromine", "79.904"],
  [36, "Kr", "Криптон", "Криптон", "Krypton", "83.798"],
  [37, "Rb", "Рубидий", "Рубидий", "Rubidium", "85.468"],
  [38, "Sr", "Стронций", "Стронций", "Strontium", "87.62"],
  [39, "Y", "Иттрий", "Иттрий", "Yttrium", "88.906"],
  [40, "Zr", "Цирконий", "Цирконий", "Zirconium", "91.224"],
  [41, "Nb", "Ниобий", "Ниобий", "Niobium", "92.906"],
  [42, "Mo", "Молибден", "Молибден", "Molybdenum", "95.95"],
  [43, "Tc", "Технеций", "Технеций", "Technetium", "[98]"],
  [44, "Ru", "Рутений", "Рутений", "Ruthenium", "101.07"],
  [45, "Rh", "Родий", "Родий", "Rhodium", "102.91"],
  [46, "Pd", "Палладий", "Палладий", "Palladium", "106.42"],
  [47, "Ag", "Серебро", "Күміс", "Silver", "107.87"],
  [48, "Cd", "Кадмий", "Кадмий", "Cadmium", "112.41"],
  [49, "In", "Индий", "Индий", "Indium", "114.82"],
  [50, "Sn", "Олово", "Қалайы", "Tin", "118.71"],
  [51, "Sb", "Сурьма", "Сүрме", "Antimony", "121.76"],
  [52, "Te", "Теллур", "Теллур", "Tellurium", "127.60"],
  [53, "I", "Йод", "Йод", "Iodine", "126.90"],
  [54, "Xe", "Ксенон", "Ксенон", "Xenon", "131.29"],
  [55, "Cs", "Цезий", "Цезий", "Caesium", "132.91"],
  [56, "Ba", "Барий", "Барий", "Barium", "137.33"],
  [57, "La", "Лантан", "Лантан", "Lanthanum", "138.91"],
  [58, "Ce", "Церий", "Церий", "Cerium", "140.12"],
  [59, "Pr", "Празеодим", "Празеодим", "Praseodymium", "140.91"],
  [60, "Nd", "Неодим", "Неодим", "Neodymium", "144.24"],
  [61, "Pm", "Прометий", "Прометий", "Promethium", "[145]"],
  [62, "Sm", "Самарий", "Самарий", "Samarium", "150.36"],
  [63, "Eu", "Европий", "Европий", "Europium", "151.96"],
  [64, "Gd", "Гадолиний", "Гадолиний", "Gadolinium", "157.25"],
  [65, "Tb", "Тербий", "Тербий", "Terbium", "158.93"],
  [66, "Dy", "Диспрозий", "Диспрозий", "Dysprosium", "162.50"],
  [67, "Ho", "Гольмий", "Гольмий", "Holmium", "164.93"],
  [68, "Er", "Эрбий", "Эрбий", "Erbium", "167.26"],
  [69, "Tm", "Тулий", "Тулий", "Thulium", "168.93"],
  [70, "Yb", "Иттербий", "Иттербий", "Ytterbium", "173.05"],
  [71, "Lu", "Лютеций", "Лютеций", "Lutetium", "174.97"],
  [72, "Hf", "Гафний", "Гафний", "Hafnium", "178.49"],
  [73, "Ta", "Тантал", "Тантал", "Tantalum", "180.95"],
  [74, "W", "Вольфрам", "Вольфрам", "Tungsten", "183.84"],
  [75, "Re", "Рений", "Рений", "Rhenium", "186.21"],
  [76, "Os", "Осмий", "Осмий", "Osmium", "190.23"],
  [77, "Ir", "Иридий", "Иридий", "Iridium", "192.22"],
  [78, "Pt", "Платина", "Платина", "Platinum", "195.08"],
  [79, "Au", "Золото", "Алтын", "Gold", "196.97"],
  [80, "Hg", "Ртуть", "Сынап", "Mercury", "200.59"],
  [81, "Tl", "Таллий", "Таллий", "Thallium", "204.38"],
  [82, "Pb", "Свинец", "Қорғасын", "Lead", "207.2"],
  [83, "Bi", "Висмут", "Висмут", "Bismuth", "208.98"],
  [84, "Po", "Полоний", "Полоний", "Polonium", "[209]"],
  [85, "At", "Астат", "Астат", "Astatine", "[210]"],
  [86, "Rn", "Радон", "Радон", "Radon", "[222]"],
  [87, "Fr", "Франций", "Франций", "Francium", "[223]"],
  [88, "Ra", "Радий", "Радий", "Radium", "[226]"],
  [89, "Ac", "Актиний", "Актиний", "Actinium", "[227]"],
  [90, "Th", "Торий", "Торий", "Thorium", "232.04"],
  [91, "Pa", "Протактиний", "Протактиний", "Protactinium", "231.04"],
  [92, "U", "Уран", "Уран", "Uranium", "238.03"],
  [93, "Np", "Нептуний", "Нептуний", "Neptunium", "[237]"],
  [94, "Pu", "Плутоний", "Плутоний", "Plutonium", "[244]"],
  [95, "Am", "Америций", "Америций", "Americium", "[243]"],
  [96, "Cm", "Кюрий", "Кюрий", "Curium", "[247]"],
  [97, "Bk", "Берклий", "Берклий", "Berkelium", "[247]"],
  [98, "Cf", "Калифорний", "Калифорний", "Californium", "[251]"],
  [99, "Es", "Эйнштейний", "Эйнштейний", "Einsteinium", "[252]"],
  [100, "Fm", "Фермий", "Фермий", "Fermium", "[257]"],
  [101, "Md", "Менделевий", "Менделевий", "Mendelevium", "[258]"],
  [102, "No", "Нобелий", "Нобелий", "Nobelium", "[259]"],
  [103, "Lr", "Лоуренсий", "Лоуренсий", "Lawrencium", "[262]"],
  [104, "Rf", "Резерфордий", "Резерфордий", "Rutherfordium", "[267]"],
  [105, "Db", "Дубний", "Дубний", "Dubnium", "[268]"],
  [106, "Sg", "Сиборгий", "Сиборгий", "Seaborgium", "[271]"],
  [107, "Bh", "Борий", "Борий", "Bohrium", "[272]"],
  [108, "Hs", "Хассий", "Хассий", "Hassium", "[270]"],
  [109, "Mt", "Мейтнерий", "Мейтнерий", "Meitnerium", "[276]"],
  [110, "Ds", "Дармштадтий", "Дармштадтий", "Darmstadtium", "[281]"],
  [111, "Rg", "Рентгений", "Рентгений", "Roentgenium", "[280]"],
  [112, "Cn", "Коперниций", "Коперниций", "Copernicium", "[285]"],
  [113, "Nh", "Нихоний", "Нихоний", "Nihonium", "[286]"],
  [114, "Fl", "Флеровий", "Флеровий", "Flerovium", "[289]"],
  [115, "Mc", "Московий", "Московий", "Moscovium", "[290]"],
  [116, "Lv", "Ливерморий", "Ливерморий", "Livermorium", "[293]"],
  [117, "Ts", "Теннессин", "Теннессин", "Tennessine", "[294]"],
  [118, "Og", "Оганесон", "Оганесон", "Oganesson", "[294]"],
];

// Group headers: 1–18 with the A/B numbering of the short form that school textbooks also use.
export const GROUP_LABELS = [
  "IA", "IIA", "IIIB", "IVB", "VB", "VIB", "VIIB", "VIIIB", "VIIIB",
  "VIIIB", "IB", "IIB", "IIIA", "IVA", "VA", "VIA", "VIIA", "VIIIA",
];

// Period and group of an element. Lanthanides and actinides stand in group 3 and are drawn in the two
// rows under the table (`fRow` 1 or 2, `fColumn` 0–14).
const placeOf = (n) => {
  if (n <= 2) return { period: 1, group: n === 1 ? 1 : 18 };
  if (n <= 18) {
    const period = n <= 10 ? 2 : 3;
    const offset = n - (period === 2 ? 2 : 10);
    return { period, group: offset <= 2 ? offset : offset + 10 };
  }
  if (n <= 54) {
    const period = n <= 36 ? 4 : 5;
    return { period, group: n - (period === 4 ? 18 : 36) };
  }
  if (n >= 57 && n <= 71) return { period: 6, group: 3, fRow: 1, fColumn: n - 57 };
  if (n >= 89 && n <= 103) return { period: 7, group: 3, fRow: 2, fColumn: n - 89 };
  if (n <= 86) return { period: 6, group: n <= 56 ? n - 54 : n - 68 };
  return { period: 7, group: n <= 88 ? n - 86 : n - 100 };
};

// The electron family that colours the cell, as in school tables (helium is an s-element).
const blockOf = (n, { group, fRow }) => {
  if (fRow) return "f";
  if (group <= 2 || n === 2) return "s";
  return group >= 13 ? "p" : "d";
};

// `row` and `col` place the cell in the drawn grid: row 1 holds the group numbers and column 1 the
// period numbers; rows 10–11 are the lanthanides and actinides, under groups 3–17.
export const ELEMENTS = ROWS.map(([number, symbol, ru, kk, en, mass]) => {
  const place = placeOf(number);
  return {
    number,
    symbol,
    names: { ru, kk, en },
    mass,
    ...place,
    block: blockOf(number, place),
    row: place.fRow ? 9 + place.fRow : place.period + 1,
    col: place.fRow ? place.fColumn + 4 : place.group + 1,
  };
});
